/**
 * useIsExternalPartner
 *
 * True when the active company is an external PARTNER (e.g. a supplier onboarded
 * via vendor-onboarding) rather than an internal PRIMARY_ENTERPRISE company.
 * External partners get a minimal portal shell.
 */
import { useAuth } from './useAuth';

export function useIsExternalPartner(): boolean {
  const { company, accessibleCompanies, activeCompanyId } = useAuth();
  const type =
    company?.type ??
    accessibleCompanies.find((c) => c.id === activeCompanyId)?.type;
  return type === 'PARTNER';
}

export default useIsExternalPartner;
